export default __webpack_public_path__ + "static/licence-ACT-532a609f7caa82453415c208c1464f33.svg";